const LANGUAGE_DEFINITIONS = Object.freeze([
    { id: 'EN', code: 'en', label: 'English' },
    { id: 'ES', code: 'es', label: 'Spanish' },
]);

/**
 * Output: eg. { EN: 'en', ES: 'es' }
 */
export const LANGUAGE_CODES = Object.freeze(
    Object.fromEntries(LANGUAGE_DEFINITIONS.map((lang) => [lang.id, lang.code]))
);

/**
 * Output: [{ key: 'en', value: 'English' }, ...]
 */
export const LANGUAGE_OPTIONS = Object.freeze(
    LANGUAGE_DEFINITIONS.map((lang) => ({
        key: lang.code, // The actual form value (e.g., 'en')
        value: lang.label, // The human-readable text (e.g., 'English')
    }))
);

/**
 * Output: ['en', 'es']
 */
export const SUPPORTED_LOCALES = Object.freeze(Object.values(LANGUAGE_CODES));

export const DEFAULT_LOCALE = LANGUAGE_CODES.EN;

// Namespaces
export const NAMESPACES = Object.freeze({
    COMMON: 'common',
    ASSIGNMENT: 'assignment',
});

export const DEFAULT_NAMESPACE = NAMESPACES.COMMON;
